import React from 'react';

import cx from 'classnames';
import getColourPropsByColourSchemaAndCampaignColor from 'utils/getColourPropsByColourSchemaAndCampaignColor';

import GalleryTile, {
  GalleryTileProps,
} from 'components/GalleryTile/GalleryTile';
import LinkButtonRow from 'components/LinkButtonRow/LinkButtonRow';
import { ICampaignContent } from 'models/campaignContent';

interface IProps extends Omit<GalleryTileProps, 'image'> {
  campaignContent: ICampaignContent;
  colour: string;
}
const GalleryTileCampaignContent: React.FC<IProps> = ({
  campaignContent,
  colour,
  className,
  ...props
}) => {
  const { backgroundColor, btnVariant } =
    getColourPropsByColourSchemaAndCampaignColor(
      colour,
      campaignContent.colour_schema?.name,
    );
  return (
    <GalleryTile
      {...props}
      style={{ backgroundColor }}
      image={campaignContent.content_media}
      imageAlt={campaignContent.content_media_alt}
      className={cx('p-3 w-100 flex-grow-1', className)}
    >
      {campaignContent.heading && (
        <h2
          className="text-secondary text-bold mb-3"
          data-content="campaign_content_heading"
        >
          {campaignContent.heading}
        </h2>
      )}
      <div
        className="text-white text-bold"
        data-content="campaign_content_sub_heading"
        dangerouslySetInnerHTML={{ __html: campaignContent.sub_heading }}
      />
      <LinkButtonRow
        btnProps={{ variant: btnVariant }}
        links={campaignContent.links || []}
      />
    </GalleryTile>
  );
};

export default GalleryTileCampaignContent;
